import { render, staticRenderFns } from "./super-table.vue?vue&type=template&id=1ad3fe7a&"
import script from "./super-table.vue?vue&type=script&lang=js&"
export * from "./super-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports